import { make } from 'vuex-pathify'

const state = {
  trafficMessages: [],
  duaMessages: [],
  selectedDuaMessageUUID: null,
  selectedTrafficMessageUUID: null,
  isHistoryEvent: false
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations
}
